"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var undoActions = require("owa-mail-undo");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
/**
 * Helper method to trigger the confirm dialog before processing mark as phishing
 * @param markAsPhishingActionHandler callback after user confirms the mark as phishing action
 */
function confirmMarkAsPhishing(markAsPhishingActionHandler) {
    undoActions.clearLastUndoableAction();
    return owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.phishingDialogTitle, owa_mail_strings_1.default.phishingSubText, false /* resolveImmediately */, {
        okText: owa_mail_strings_1.default.reportPhishing,
        cancelText: owa_mail_strings_1.default.dontReportPhishing,
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then(function (response) {
        if (response === 0 /* ok */) {
            markAsPhishingActionHandler();
        }
    });
}
exports.default = confirmMarkAsPhishing;
//# sourceMappingURL=confirmMarkAsPhishing.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/confirmMarkAsPhishing.js
// module id = 3469
// module chunks = 62